import { defineStore } from 'pinia';
export interface LayoutState {
  extendedSidebar: boolean;
  theaterSidebarCollapsed: boolean;
  getCtaVisible: boolean;
  backButtonVisible: boolean;
}

export const useLayoutStore = defineStore('layoutStore', {
  state: () =>
    ({
      extendedSidebar: true,
      theaterSidebarCollapsed: false,
      getCtaVisible: true,
      backButtonVisible: false,
    }) as LayoutState,
  actions: {
    toggleExtendedSidebar() {
      this.extendedSidebar = !this.extendedSidebar;
    },
    hideSidebar() {
      this.extendedSidebar = false;
    },
    setTheaterSidebarCollapsed(isCollapsed: boolean) {
      this.theaterSidebarCollapsed = isCollapsed;
    },
    showCta() {
      this.getCtaVisible = true;
    },
    hideCta() {
      this.getCtaVisible = false;
    },
    showBackButton() {
      this.backButtonVisible = true;
    },
    hideBackButton() {
      this.backButtonVisible = false;
    },
  },
  getters: {
    isSidebarExpanded: state => state.extendedSidebar && !state.theaterSidebarCollapsed,
    isCtaVisible: state => state.getCtaVisible,
    isBackButtonVisible: state => state.backButtonVisible,
  },
  persist: {
    paths: ['extendedSidebar'],
  },
});
